import TpEvaluatorSearchParams from './TpEvaluatorSearchParams';

export default class TpEvaluatorTextMessageSearchParams extends TpEvaluatorSearchParams {
  additionalInitialization() {
    this.TypeOfExport = 'TextMessageExport';
    this.Status = 'Contact';
    this.EmailOptOut = null;
    this.EmailOptOutPlaceholder = null;
    this.EmailVerified = null;
    this.EmailVerifiedPlaceholder = null;
    this.IncludeSelfDeactivated = false;
    this.IncludeSelfDeactivatedPlaceholder = 'No';
    this.TextAllow = true;
    this.TextAllowPlaceholder = 'Yes';
    this.IncludeNATextMessageAuthorized = false;
    this.IncludeNATextMessageAuthorizedPlaceholder = 'No';
  }
}
